export enum ApiRoutes {
    LOGIN = 'user/account/login',
    CREATE_USER = '',
    DASHBOARD = '',
}
